import { Ref, useEffect, useRef } from 'react'

// https://medium.com/@bugfact/you-could-also-use-usecallback-and-pass-the-callback-as-the-ref-value-to-the-button-17de78bc9e6e
// https://gist.github.com/pie6k/b4717f392d773a71f67e110b42927fea
function useShareForwardedRef<T>(forwardedRef: Ref<T>) {
  // final ref that will share value with forward ref. this is the one we will attach to components
  const innerRef = useRef<T>(null)

  useEffect(() => {
    // after every render - try to share current ref value with forwarded ref
    if (!forwardedRef) {
      return
    }
    if (typeof forwardedRef === 'function') {
      forwardedRef(innerRef.current)
      return
    }

    // eslint-disable-next-line no-param-reassign
    (forwardedRef as any).current = innerRef.current
  })

  return innerRef
}

export default useShareForwardedRef
